import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { ErrorMessage, Field } from '../FormikCustom';
import { Button } from 'react-bootstrap';
import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import ContactInfo from '../Layout/ContactInfo';
import Spinner from '../Spinner/Spinner';
import Dialog from '../Dialogs/Dialog';
import SpinnerText from '../SpinnerText/SpinnerText';



class LoginForm extends Component {
  componentDidMount() {
    document.title = 'MyAccount Manager';
  }
  render() {
    if (this.props.LoggedIn) {
      return <Redirect to="/" />;
    }

    const onSubmitHandler = (values) => {
      this.props.requestLogin(values.email, values.password, false);
    };

    const LoginSchema = Yup.object().shape({
      password: Yup.string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
      email: Yup.string()
        .email('Invalid email')
        .max(256, 'Too Long!')
        .required('Required')
    });

    const getUserFriendlyErrorMessage = (err) => {
      if (!err) return null; // keep your current contract

      // If it's a string already
      if (typeof err === 'string') {
        const s = err.trim();
        return s || 'Unknown error occurred';
      }

      // If it's an Error instance
      if (err instanceof Error) {
        const s = (err.message || '').trim();
        return s || 'Unknown error occurred';
      }

      // Axios / fetch style: peel off response.data
      const data = err?.response?.data ?? err;

      // If after peeling it's a string
      if (typeof data === 'string') {
        const s = data.trim();
        return s || 'Unknown error occurred';
      }

      // Ensure it's a plain object (not null/array)
      if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return 'Unknown error occurred';
      }

      // Candidate fields in preferred order
      const candidates = [
        data.error_description,
        data.description,
        data.ExceptionMessage,
        data.Message,
        data.message,          // common in many APIs
        data.title,            // problem+json / some APIs
        data.detail,           // RFC 7807 "detail"
        data.statusText        // fetch Response-like
      ];

      for (const c of candidates) {
        if (typeof c === 'string' && c.trim()) {
          return c.trim();
        }
      }

      // Nothing useful—last resort: stringify small objects
      try {
        const s = JSON.stringify(data);
        if (s && s.length <= 300) return s; // avoid dumping huge objects
      } catch (_error) {
        // ignore stringify errors
      }

      return 'Unknown error occurred';
    };

    // usage
    const loginErrorMessage = getUserFriendlyErrorMessage(this.props.LoginError);
    
    const serverError = loginErrorMessage ? (
      <Dialog title="Login error" message={loginErrorMessage} />
    ) : null;

    const spinner = this.props.IsLoginInProgress ? <Spinner /> : null;



    return (
      <React.Fragment>
        <div className="login-container">
          <p className="button-examples">
            <Button type="button">Unset</Button>
            <Button type="button" bsStyle="default">Default</Button>
            <Button type="button" bsStyle="primary">Primary</Button>
            <Button type="button" bsStyle="success">Success</Button>
            <Button type="button" bsStyle="info">Info</Button>
            <Button type="button" bsStyle="warning">Warning</Button>
            <Button type="button" bsStyle="danger">Danger</Button>
            <Button type="button" bsStyle="link">Link</Button>
          </p>
          <p className="button-examples">
            <Button type="button" disabled>Unset</Button>
            <Button type="button" bsStyle="default" disabled>Default</Button>
            <Button type="button" bsStyle="primary" disabled>Primary</Button>
            <Button type="button" bsStyle="success" disabled>Success</Button>
            <Button type="button" bsStyle="info" disabled>Info</Button>
            <Button type="button" bsStyle="warning" disabled>Warning</Button>
            <Button type="button" bsStyle="danger" disabled>Danger</Button>
            <Button type="button" bsStyle="link" disabled>Link</Button>
          </p>
          <Formik
            ref={this.formRefs}
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={LoginSchema}
            enableReinitialize={true}
            onSubmit={onSubmitHandler}
          >
            {props => (
              <React.Fragment>
                <Form className="loginForm">
                  <h4>Log in to view account details:</h4>
                  <div className="form-group">
                    <Field
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email Address"
                      autoFocus
                    />
                    <ErrorMessage
                      component="div"
                      className="errorMessage"
                      name="email"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Password"
                    />
                    <ErrorMessage
                      component="div"
                      className="errorMessage"
                      name="password"
                    />
                  </div>
                  {serverError}

                  <Button
                    type="submit"
                    className="btn-full loading"
                    bsStyle="primary"
                    bsSize="large"
                    disabled={
                      this.props.IsLoginInProgress ||
                      Object.keys(props.errors).length > 0
                    }
                  >
                    <SpinnerText
                      text="Log In"
                      loading={this.props.IsLoginInProgress}
                    />
                  </Button>
                  <div className="row">
                    <div className="text-center">
                      <Link

                        to={{
                          pathname: '/forgotpassword',
                          state: { email: props.values.email }
                        }}
                      >Having trouble logging in?</Link>
                    </div>
                  </div>
                  <div className="login-separator">
                    <span className="text-in-separator">or</span>
                  </div>
                  <div className="row">
                    <div className="text-center">
                      <Link className="btn btn-info btn-lg btn-full loading" to="/register">
                        Register New User
                      </Link>
                    </div>
                  </div>

                </Form>

              </React.Fragment>
            )}
          </Formik>
          {spinner}
          <div className="login-contact">
            <ContactInfo />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default connect(
  state => state.login,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(LoginForm);


